export default (date: Date) =>
    [
        date.getFullYear(),
        `0${date.getMonth() + 1}`.slice(-2),
        `0${date.getDate()}`.slice(-2),
    ].join('-');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/utils/url/slugifyDate.ts